<template>
    <div class="gallery-modal-wrapper">
        <!-- TOP RIGHT CORNER - CONTROLLS  -->
        <div class="gallery-modal-controlls">
        <div v-if="!isGallerySingle" class="modal-image-counter">{{activeImage + 1}}/{{picturesArray.length}}</div>
        <div v-if="isGallerySingle" class="modal-image-counter">{{picturesArray.length}} IMAGES</div>
        <a class="alcomet gallery-modal-btn" @click="toggleGalleryMode()">
            <template v-if="isGallerySingle">K</template>
            <template v-if="!isGallerySingle">J</template>
        </a>
        <a class="alcomet gallery-modal-btn" @click="closeGallery()">H</a>
        </div>
        <!-- MODAL ITSELF -->
        <div class="gallery-modal">
        <!-- PREV ARROW -->
        <div v-if="!isGallerySingle" class="gallery-modal-arrow" @click="prevImage()"><span class="alcomet">N</span></div>
        <transition-group mode="out-in" :name="slideDirection">
            <!-- ALL IMAGES ABSOLUTELY POSITIONED ON TOP OF EACH OTHER -->
            <div v-show="index == activeImage" v-for="(image, index) in picturesArray" :key="index" v-if="!isGallerySingle" :style="{backgroundImage: 'url(' + prefix + image + ')'}" class="gallery-modal-single"></div>
        </transition-group>
        <!-- NEXT ARROW -->
        <div v-if="!isGallerySingle" class="gallery-modal-arrow" @click="nextImage()"><span class="alcomet">O</span></div>
        <!-- MULTIPLE IMAGES WINDOW -->
        <div v-if="isGallerySingle" class="gallery-modal-list">
            <div v-for="(image, index) in picturesArray" :key="index" :style="{backgroundImage: 'url(' + prefix + image + ')'}" @click="chooseImage(index)"></div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["picturesArray", "eventName", "prefix"],
  data() {
    return {
      slideDirection: "slide-fade-right",
      activeImage: 0,
      isGallerySingle: true
    };
  },
  methods: {
    // Multiple/Single image mode
    toggleGalleryMode() {
      this.isGallerySingle = this.isGallerySingle == false ? true : false;
    },
    // When Multi-image mode is active, when chosing an image
    // Single-image mode becomes active and the chosen image is selected
    chooseImage(index) {
      this.activeImage = index;
      this.isGallerySingle = false;
    },
    prevImage() {
      this.slideDirection = "slide-fade-right";
      if (this.activeImage > 0) {
        this.activeImage--;
      } else {
        this.activeImage = this.picturesArray.length - 1;
      }
    },
    nextImage() {
      this.slideDirection = "slide-fade-left";
      if (this.activeImage < this.picturesArray.length - 1) {
        this.activeImage++;
      } else {
        this.activeImage = 0;
      }
    },
    closeGallery() {
      this.$eventHub.$emit(this.eventName);
    }
  }
};
</script>

<style>
/* MODAL */
.gallery-modal-wrapper {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}
/* GALLERY CONTROLS */
.gallery-modal-controlls {
  display: flex;
  position: absolute;
  right: 0;
  top: 0;
}
.gallery-modal {
  align-items: center;
  display: flex;
  height: 90vh;
  justify-content: center;
  position: relative;
  width: 90%;
}
.gallery-modal-btn,
.modal-image-counter {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: center;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 40px;
}
.modal-image-counter {
  width: initial;
  width: auto;
  padding-right: 10px;
}
.gallery-modal-btn:hover {
  background-color: #004787;
  color: #fff;
}
.gallery-modal-single {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.gallery-modal-arrow {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  border: 1px solid #dde7ee;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 50px;
  justify-content: center;
  margin: 5px 0;
  position: absolute;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 50px;
  z-index: 1;
}
.gallery-modal-arrow:hover {
  background-color: #dde7ee;
}
.gallery-modal-arrow:first-child {
  left: 10%;
}
.gallery-modal-arrow:last-child {
  right: 10%;
}
.gallery-modal-list {
  align-self: flex-start;
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  max-width: 100%;
  max-height: 100%;
  padding: 20px;
  width: 100%;
}
.gallery-modal-list div {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(221, 231, 238, 0.3);
  border: 1px solid #dde7ee;
  cursor: pointer;
  height: 200px;
  margin: 10px;
  width: calc(25% - 20px);
}
/* TRANSITIONS */
.slide-fade-right-enter-active,
.slide-fade-right-leave-active,
.slide-fade-left-enter-active,
.slide-fade-left-leave-active {
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.slide-fade-right-enter,
.slide-fade-left-leave-to {
  opacity: 0;
  transform: translate(-100%);
}
.slide-fade-right-leave-to,
.slide-fade-left-enter {
  opacity: 0;
  transform: translateX(100%);
}
@media screen and (max-width: 1000px) {
  .gallery-modal-list div {
    height: 100px;
    width: calc(33.33% - 20px);
  }
  .gallery-modal-arrow:first-child {
    left: 0;
  }
  .gallery-modal-arrow:last-child {
    right: 0;
  }
}
@media screen and (max-width: 600px) {
  .gallery-modal-list div {
    height: 100px;
    width: calc(50% - 20px);
  }
  .gallery-modal-arrow {
    height: 40px;
    width: 40px;
  }
  .gallery-modal-arrow > span {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Gallery.vue